module.exports = __webpack_public_path__ + "static/media/4.39652217.jpg";